import React, { PureComponent } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { message, Button, Input, Select, Upload } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import fetchHandler from "@/fetch/fetchHandler";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { lockBind, prefixFile } from "../../../fetch/fetchApi";

const FormItem = Form.Item;
var loading = false;
const uploadButton = (
  <div>
    {loading ? <LoadingOutlined /> : <PlusOutlined />}
    <div style={{ marginTop: 8 }}>Upload</div>
  </div>
);

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class StubBindLockClass extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
      imageUrl: null,
      internationalization: this.props.intl.messages.stubBindLock,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (values.lockId.length > 50) {
          message.error("地锁编号最大长度不能超过50个字符");
          return;
        }
        if (values.lockBrand.toString() === "4") {
          if (values.hubId == null || values.hubId == "") {
            message.error("请输入地锁网关");
            return;
          }
          if (values.hubId.length > 50) {
            message.error("地锁网关最大长度不能超过50个字符");
            return;
          }
        }
        this.setState({
          btnLoading: true,
        });
        values.stubId = this.props.stubId;
        fetchHandler(lockBind, {
          ...values,
        }).then((res) => {
          if (this.props.setSelectedRowKeysNull) {
            this.props.setSelectedRowKeysNull();
          }
          if (res && res.code === "success") {
            message.success(this.state.internationalization.msg1); // '操作成功');
            if (this.props.onCancel) {
              this.props.onCancel();
            }
            if (this.props.refreshGrid) {
              this.props.refreshGrid();
            }
          }
          this.setState({
            btnLoading: false,
          });
        });
      }
    });
  };

  checkLength(rule, value, callback, item) {
    if ((value && value.length > item) || (value && value.length < 1)) {
      callback(
        `${this.state.internationalization.msg2 - 1}0${
          this.state.internationalization.msg2 - 2
        }${item}${this.state.internationalization.msg2 - 3}`,
      );
    }
    callback();
  }

  getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  render() {
    const uploadProps = {
      name: "file",
      multiple: false,
      listType: "picture-card",
      className: "avatar-uploader",
      // accept: ".xls",
      action: `${prefixFile}/filesUploadOne.do`,
      headers: {
        authorization: "authorization-text",
      },
      showUploadList: false,
      // progress:{
      //     type:'line'
      // },
      onChange: (info) => {
        console.info(info.file.response);
        if (info.file.response != undefined && info.file.response.code == "200") {
          console.info(info.file.response.data.url);
          this.setState({
            imageUrl: info.file.response.data.url,
          });
        } else if (info.file.response === undefined) {
        } else {
          message.error(`${info.file.name}上传失败`);
        }
      },
    };
    const sortTypeOption = [
      { label: "开迈斯地锁", value: "0" },
      { label: "蓝牙", value: "1" },
      { label: "慧铂金", value: "2" },
      { label: "万科地锁", value: "3" },
      { label: "丁丁地锁", value: "4" },
      { label: "豪位地锁", value: "5" },
      { label: "克莱玛地锁", value: "9" },
    ];
    const { getFieldDecorator } = this.props.form;
    const tailFormItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 16, offset: 5 },
      },
    };
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12, offset: 1 },
      },
    };
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label={"地锁编号"}>
            {getFieldDecorator("lockId", {
              rules: [
                {
                  required: true,
                  message: "请输入地锁编号",
                },
              ],
              initialValue: this.props.stubId == null ? null : this.props.stubId.deviceModel,
            })(<Input />)}
          </FormItem>

          <FormItem {...formItemLayout} label={"地锁品牌"}>
            {getFieldDecorator("lockBrand", {
              rules: [
                {
                  required: true,
                  message: "请选择要地锁品牌", // "请选择要地锁品牌"
                },
              ],
            })(
              <Select
                placeholder="请选择"
                onSelect={(value, option) => {
                  if (value != null && value.toString() === "4") {
                    this.setState({
                      hidden: false,
                    });
                  } else {
                    this.setState({
                      hidden: true,
                    });
                  }
                }}>
                {sortTypeOption.map((item) => {
                  return (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  );
                })}
              </Select>,
            )}
          </FormItem>

          <FormItem
            hidden={this.state.hidden}
            name="hubId"
            {...formItemLayout}
            label={"地锁网关编号"}>
            {getFieldDecorator("hubId", {})(<Input />)}
          </FormItem>

          <FormItem {...formItemLayout} label={"地锁二维码地址"}>
            {getFieldDecorator("qrCode", {
              rules: [
                {
                  required: true,
                  message: "请输入地锁二维码地址",
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem {...tailFormItemLayout} style={{ marginTop: 14 }}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={this.state.btnDisabled}
              loading={this.state.btnLoading}>
              {this.state.internationalization.btn1}
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

const StubBindLock = Form.create()(StubBindLockClass);

export default injectIntl(StubBindLock);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubBindLock.js